import React, { FC } from 'react';
import { CartDto } from '../../../../../../../generated-api';
import CartItem from './CartItem';
import { getUniqueOrderLineKey } from '../../../../../../utils/orderLineUtils';

type Props = {
  orderLines: CartDto['orderLines'];
};

const CartItems: FC<Props> = ({ orderLines }) => {
  return (
    <ul className="overflow-auto h-full">
      {orderLines.map((order) => (
        <CartItem key={`${getUniqueOrderLineKey(order)}`} orderLine={order} />
      ))}
    </ul>
  );
};

export default CartItems;
